import './App.css';
import FireSuppressionCalculator from './Component/FireSuppressionCalculator';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <FireSuppressionCalculator />
  );
}

export default App;
